import { Op } from 'quill';

/**
 * Extracts plain text from Quill Delta operations (Op[]), including mention embeds.
 *
 * @param ops The Quill Delta operations array.
 * @returns The extracted plain text string.
 */
export function extractTextFromOps(ops: Op[] | null | undefined): string {
  if (!ops) return '';
  return ops
    .map((op) => {
      if (typeof op.insert === 'string') {
        return op.insert;
      } else if (typeof op.insert === 'object' && op.insert !== null) {
        if ('mention' in op.insert) {
          const mention = op.insert.mention as {
            value?: string;
            id?: string;
            type?: string;
          };
          return `@${mention.value || ''}`;
        }
        if ('emoji' in op.insert) {
          const emoji = op.insert.emoji as {
            native?: string;
          };
          return emoji?.native || '';
        }
        return '';
      }
      return '';
    })
    .join('');
}

/**
 * Whether the delta holds any user content. Embeds (mentions, emojis) produce
 * no plain text, so checking the extracted text alone would treat a
 * mention-only delta as empty.
 */
export function hasOpsContent(ops: Op[] | null | undefined): boolean {
  if (!ops) return false;
  return ops.some(
    (op) =>
      (typeof op.insert === 'string' && op.insert.trim().length > 0) ||
      (typeof op.insert === 'object' && op.insert !== null),
  );
}
